import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ChipTypeConstant, ChipTypeConstantType } from "@app/shared/constants/chip/chip-type";

@Component({
    selector: "app-chip",
    templateUrl: "./chip.component.html",
    styleUrls: ["./chip.component.css"],
    standalone: false
})
export class ChipComponent {
  @Output() close = new EventEmitter<void>();
  @Input() closeable: boolean = false;
  @Input() text: string = "";
  @Input()
  set type(value: ChipTypeConstantType) {
    if (this._type === ChipTypeConstant.ERROR && value === ChipTypeConstant.DEFAULT) {
      return;
    }

    this._type = value;
  };

  get type(): ChipTypeConstantType {
    return this._type;
  };

  private _type: ChipTypeConstantType = ChipTypeConstant.DEFAULT;

  onClose(): void {
    this.close.emit();
  };

  displayIconForChipType(): boolean {
    if (this._type.icon === "none") {
      return false;
    }

    return this._type?.kind !== 'default' && this._type?.kind !== 'example-prompt'
  }
}
